import { makeNewsSchema } from './makeNewsSchema';
export const stringifyNewsSchema = ({ title, author, abstract, image, url, publishedDate, siteUrl, }) => {
    const newsSchema = makeNewsSchema({
        title: title,
        author: author,
        abstract: abstract,
        image: image,
        url: url,
        publishedDate: publishedDate,
        siteUrl: siteUrl,
    });
    return JSON.stringify(newsSchema, null, 2);
};
export default stringifyNewsSchema;
